/**
 * ProductRelated Component
 */
(function () {

    'use strict';

    /**
     * Product Swiper Related products
     * @name productRelatedCtrl
     * @type ItxProductRelatedCmpCtrl
     */
    var ItxProductRelatedCmp = {
        controller: ItxProductRelatedCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'ItxProductRelatedCmp.html'
    };

    ItxProductRelatedCmpCtrl.$inject = ['ItxScreenSizeSvc', 'ItxProductSwiperSvc'];

    function ItxProductRelatedCmpCtrl(ItxScreenSizeSvc, ItxProductSwiperSvc) {
        var _this = this;

        _this.ItxProductSwiperSvc = ItxProductSwiperSvc;

        _this.mobile = ItxScreenSizeSvc.is('xs,sm');

        _this.wideEyesEnabled = ItxProductSwiperSvc.wideEyesEnabled;

        _this.showRelatedProducts = true;

    }

    /** Public */
    angular.module('itxApp.catalog')
        .component('itxProductRelated', ItxProductRelatedCmp);

})();
